module.exports = __webpack_public_path__ + "static/media/linkedin.5b97f198.png";